// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uM2d","buttons":"styles_buttons__27fIx"};